import { defineComponent } from '@vue/composition-api';
import { BfSpinner } from 'components/Butterfly';
const ConceptList = defineComponent({
    components: {
        BfSpinner,
    },
    props: {
        isLoading: { type: Boolean, required: false, default: false },
        concepts: { type: Array, required: false, default: () => [] },
        unmappedConcepts: { type: Array, required: false, default: () => [] },
        headerLeft: { type: String, required: false, default: 'Concepts' },
        headerRight: { type: String, required: false, default: 'Coverage' },
        emptyMessage: { type: String, required: false, default: 'No concepts found.' },
    },
    setup(props, { emit }) {
        const clickConcept = (concept, e) => {
            const el = e.target?.closest('.concept-item');
            el && emit('concept-clicked', concept.name, el);
        };
        return {
            clickConcept,
        };
    }
});
export default ConceptList;
